"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _useTranslatedLabels = _interopRequireDefault(require("../useTranslatedLabels"));

var _Button = _interopRequireDefault(require("../button/Button"));

var _Select = _interopRequireDefault(require("../select/Select"));

var _Icons = require("./Icons");

var _BackgroundColorContext = require("../BackgroundColorContext");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DxcPaginator = function DxcPaginator(_ref) {
  var _ref$currentPage = _ref.currentPage,
      currentPage = _ref$currentPage === void 0 ? 1 : _ref$currentPage,
      _ref$itemsPerPage = _ref.itemsPerPage,
      itemsPerPage = _ref$itemsPerPage === void 0 ? 5 : _ref$itemsPerPage,
      itemsPerPageOptions = _ref.itemsPerPageOptions,
      _ref$totalItems = _ref.totalItems,
      totalItems = _ref$totalItems === void 0 ? 1 : _ref$totalItems,
      showGoToPage = _ref.showGoToPage,
      onPageChange = _ref.onPageChange,
      itemsPerPageFunction = _ref.itemsPerPageFunction,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;
  var totalPages = Math.ceil(totalItems / itemsPerPage);
  var currentPageInternal = currentPage === -1 ? totalPages : currentPage;
  var minItemsPerPage = currentPageInternal === 1 || currentPageInternal === 0 ? currentPageInternal : (currentPageInternal - 1) * itemsPerPage + 1;
  var maxItemsPerPage = minItemsPerPage - 1 + itemsPerPage > totalItems ? totalItems : minItemsPerPage - 1 + itemsPerPage;
  var colorsTheme = (0, _useTheme["default"])();
  var translatedLabels = (0, _useTranslatedLabels["default"])();
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.paginator
  }, /*#__PURE__*/_react["default"].createElement(_BackgroundColorContext.BackgroundColorProvider, {
    color: colorsTheme.paginator.backgroundColor
  }, /*#__PURE__*/_react["default"].createElement(DxcPaginatorContainer, {
    disabled: currentPageInternal === 1
  }, /*#__PURE__*/_react["default"].createElement(LabelsContainer, null, itemsPerPageOptions && /*#__PURE__*/_react["default"].createElement(ItemsPageContainer, null, /*#__PURE__*/_react["default"].createElement(ItemsLabel, null, translatedLabels.paginator.itemsPerPageText), /*#__PURE__*/_react["default"].createElement(SelectContainer, null, /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    options: itemsPerPageOptions.map(function (num) {
      return {
        label: num.toString(),
        value: num.toString()
      };
    }),
    onChange: function onChange(newValue) {
      itemsPerPageFunction(Number(newValue.value));
    },
    value: itemsPerPage.toString(),
    size: "fillParent",
    tabIndex: tabIndex
  }))), /*#__PURE__*/_react["default"].createElement(TotalItemsContainer, null, translatedLabels.paginator.minToMaxOfText(minItemsPerPage, maxItemsPerPage, totalItems)), onPageChange && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    size: "small",
    mode: "secondary",
    disabled: currentPageInternal === 1 || currentPageInternal === 0,
    icon: _Icons.firstIcon,
    tabIndex: tabIndex,
    onClick: function onClick() {
      onPageChange(1);
    }
  }), onPageChange && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    size: "small",
    mode: "secondary",
    disabled: currentPageInternal === 1 || currentPageInternal === 0,
    icon: _Icons.previousIcon,
    tabIndex: tabIndex,
    onClick: function onClick() {
      onPageChange(currentPage - 1);
    }
  }), showGoToPage && /*#__PURE__*/_react["default"].createElement(PageToSelectContainer, null, /*#__PURE__*/_react["default"].createElement(GoToLabel, null, translatedLabels.paginator.goToPageText, " "), /*#__PURE__*/_react["default"].createElement(SelectContainer, null, /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    options: Array.from(Array(totalPages), function (e, num) {
      return {
        label: (num + 1).toString(),
        value: (num + 1).toString()
      };
    }),
    onChange: function onChange(newValue) {
      onPageChange(Number(newValue.value));
    },
    value: currentPage.toString(),
    size: "fillParent",
    tabIndex: tabIndex
  }))) || /*#__PURE__*/_react["default"].createElement(TextContainer, null, translatedLabels.paginator.pageOfText(currentPageInternal, totalPages)), onPageChange && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    size: "small",
    mode: "secondary",
    disabled: currentPageInternal === totalPages,
    icon: _Icons.nextIcon,
    tabIndex: tabIndex,
    onClick: function onClick() {
      onPageChange(currentPage + 1);
    }
  }), onPageChange && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    size: "small",
    mode: "secondary",
    disabled: currentPageInternal === totalPages,
    icon: _Icons.lastIcon,
    tabIndex: tabIndex,
    onClick: function onClick() {
      onPageChange(totalPages);
    }
  })))));
};

var DxcPaginatorContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n  text-transform: ", ";\n  background-color: ", ";\n  color: ", ";\n  padding: ", " ", ";\n\n  button {\n    &:disabled {\n      background-color: transparent !important;\n      opacity: 0.3 !important;\n    }\n  }\n"])), function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.fontSize;
}, function (props) {
  return props.theme.fontWeight;
}, function (props) {
  return props.theme.fontStyle;
}, function (props) {
  return props.theme.fontTextTransform;
}, function (props) {
  return props.theme.backgroundColor;
}, function (props) {
  return props.theme.fontColor;
}, function (props) {
  return props.theme.verticalPadding;
}, function (props) {
  return props.theme.horizontalPadding;
});

var SelectContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  min-width: 5.25rem;\n"])));

var ItemsPageContainer = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  margin-right: ", ";\n  margin-left: ", ";\n\n  label {\n    height: 0px;\n  }\n  label + .MuiInput-formControl {\n    margin-top: 0px;\n  }\n"])), function (props) {
  return props.theme.itemsPerPageSelectorMarginRight;
}, function (props) {
  return props.theme.itemsPerPageSelectorMarginLeft;
});

var ItemsLabel = _styledComponents["default"].span(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-right: 0.5rem;\n"])));

var GoToLabel = _styledComponents["default"].span(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-right: 0.5rem;\n  margin-left: 0.5rem;\n"])));

var TotalItemsContainer = _styledComponents["default"].span(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-right: ", ";\n  margin-left: ", ";\n"])), function (props) {
  return props.theme.totalItemsContainerMarginRight;
}, function (props) {
  return props.theme.totalItemsContainerMarginLeft;
});

var LabelsContainer = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  gap: 0.5rem;\n  width: 100%;\n  justify-content: flex-end;\n  align-items: center;\n"])));

var PageToSelectContainer = _styledComponents["default"].span(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  margin-right: 0.5rem;\n\n  label {\n    height: 0px;\n  }\n  label + .MuiInput-formControl {\n    margin-top: 0px;\n  }\n"])));

var TextContainer = _styledComponents["default"].span(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])([""])));

var _default = DxcPaginator;
exports["default"] = _default;